import { useIsMetabolicUser } from "@/features/metabolic-health/hooks/useMetabolicHealth"
import { useProductsStore } from "@/utils/stores/useProductsStore"
import { useGetDocuments } from "./useGetDocuments"

export const useOcr = () => {
    const isMetabolicUser = useIsMetabolicUser()
    const { productsData } = useProductsStore()
    const membership = productsData.membership
    const { data: documents, isLoading } = useGetDocuments()

    const isOcrAvailable = !!(isMetabolicUser || (membership && membership.status === "active"))

    return { isOcrAvailable, data: documents, isLoading }
}